// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCv-PYRDsZw2QpCRfljxKt5pKuSKWoZ0aM",
    authDomain: "turet-website.firebaseapp.com",
    projectId: "turet-website",
    storageBucket: "turet-website.firebasestorage.app",
    messagingSenderId: "272888558782",
    appId: "1:272888558782:web:56133a50a7256239111aef"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Export services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
